import React from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { Box, Icon } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';
import { themeGet } from 'styled-system';

import withProps from '@/components/withProps/withProps';

const StyledBox = withProps({
  bg: 'background.card',
  boxShadow: 'light',
  position: 'relative',
  border: '2',
  borderColor: 'background.card',
  borderRadius: 'md',
})(styled(Box)`
  ${(props) =>
    props.isSelected &&
    css`
      border: 2px solid ${themeGet('colors.success')(props)};
      border-radius: 10px;
      box-shadow: none;
    `};
`);

const TopRightBox = withProps({
  bg: 'success',
  borderRadius: '18px',
  width: '30px',
  height: '30px',
  paddingTop: '2px',
  paddingLeft: '3px',
})(styled(Box)`
  position: absolute;
  top: -16px;
  right: -16px;
`);

const FlightsSegmentBox = React.memo(({ isSelected = false, children }) => (
  <StyledBox isSelected={isSelected}>
    {children}
    {isSelected && (
      <TopRightBox>
        <Icon color="white" name="tick" size={24} />
      </TopRightBox>
    )}
  </StyledBox>
));

FlightsSegmentBox.propTypes = {
  isSelected: PropTypes.bool,
  children: PropTypes.node,
};

export default FlightsSegmentBox;
